function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.6 0a1.4 1.4 0 011 2.3L4.9 7l-.1.1-2.2.7a.4.4 0 01-.2 0 .4.4 0 01-.2-.4l.7-2.2v-.1L7.8.4c.2-.3.6-.4 1-.4zM4.5 6.5L9 1.8A.6.6 0 009 1a.7.7 0 00-1 0L3.6 5.5 3.1 7l1.4-.4zm3.4-1.1a.4.4 0 01.7 0v3.5c0 .6-.5 1.1-1.1 1.1H1.1A1 1 0 010 9V1.7c0-.6.5-1 1-1h4.4a.4.4 0 110 .6H1c-.2 0-.4.2-.4.4v7.1c0 .2.2.4.4.4h6.4c.2 0 .4-.2.4-.4V5.4z",
  clipRule: "evenodd"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 10 10"
}, props), _ref);

export default __webpack_public_path__ + "static/media/edit.bc569c69.svg";
export { SvgComponent as ReactComponent };